import React from "react";
import StepProgressIcon from ".//..//..//..//assets//images//icons//calculator//progress.svg";
import StepCompleteIcon from ".//..//..//..//assets//images//icons//calculator//complete.svg";
import StepInactiveIcon from ".//..//..//..//assets//images//icons//calculator//inactive.svg";

const StepBar = ({ currentStepNo }) => {
  return (
    <>
      <div className="w-full ">
        <div className="flex mt-[1.1rem] ">
          <div className="w-1/6">
            <div className="relative">
              <div className="relative flex flex-col items-center text-center jus">
                <img
                  src={currentStepNo >= 2 ? StepCompleteIcon : StepProgressIcon}
                  className="w-4 h-4"
                />
                <span className="hidden lg:block  text-[0.75rem] text-[#898F8F] leading-[150%] font-normal font-poppins">
                  Ügyfél adatok
                </span>
              </div>
              {/* <div
                className="absolute  w-full ms-[7px]  h-[2px] left-1/2 top-[7px] bg-secondary-color"
                style={{ width: "calc(100% - 14px)" }}
              ></div> */}
            </div>
          </div>
          <div className="w-1/6">
            <div className="relative">
              <div className="relative flex flex-col items-center text-center jus">
                <img
                  src={
                    currentStepNo >= 3
                      ? StepCompleteIcon
                      : currentStepNo == 2
                      ? StepProgressIcon
                      : StepInactiveIcon
                  }
                  className="w-4 h-4"
                />
                <span className="hidden lg:block  text-[0.75rem] text-[#898F8F] leading-[150%] font-normal font-poppins">
                  Túratervezés
                </span>
              </div>
              {/* <div
                className="absolute  w-full ms-[7px]  h-[2px] left-1/2 top-[7px] bg-[#E0E0E7]"
                style={{ width: "calc(100% - 14px)" }}
              ></div> */}

              <div
                className={`absolute  w-full me-[7px]  h-[2px] right-1/2 top-[7px] ${
                  currentStepNo >= 2 ? "bg-secondary-color" : "bg-[#E0E0E7]"
                }`}
                style={{ width: "calc(100% - 14px)" }}
              ></div>
            </div>
          </div>
          <div className="w-1/6">
            <div className="relative">
              <div className="relative flex flex-col items-center text-center jus">
                <img
                  // src={currentStepNo >= 4 ? StepCompleteIcon : StepInactiveIcon}
                  src={
                    currentStepNo >= 4
                      ? StepCompleteIcon
                      : currentStepNo == 3
                      ? StepProgressIcon
                      : StepInactiveIcon
                  }
                  className="w-4 h-4"
                />
                <span className="hidden lg:block  text-[0.75rem] text-[#898F8F] leading-[150%] font-normal font-poppins">
                  Cím adatok
                </span>
              </div>
              {/* <div
                className="absolute  w-full ms-[7px]  h-[2px] left-1/2 top-[7px] bg-secondary-color"
                style={{ width: "calc(100% - 14px)" }}
              ></div> */}
              <div
                className={`absolute  w-full me-[7px]  h-[2px] right-1/2 top-[7px] ${
                  currentStepNo >= 3 ? "bg-secondary-color" : "bg-[#E0E0E7]"
                }`}
                style={{ width: "calc(100% - 14px)" }}
              ></div>
            </div>
          </div>
          <div className="w-1/6">
            <div className="relative">
              <div className="relative flex flex-col items-center text-center jus">
                <img
                  // src={currentStepNo >= 5 ? StepCompleteIcon : StepInactiveIcon}
                  src={
                    currentStepNo >= 5
                      ? StepCompleteIcon
                      : currentStepNo == 4
                      ? StepProgressIcon
                      : StepInactiveIcon
                  }
                  className="w-4 h-4"
                />
                <span className="hidden lg:block  text-[0.75rem] text-[#898F8F] leading-[150%] font-normal font-poppins">
                  Tétel lista
                </span>
              </div>
              {/* <div
                className="absolute  w-full ms-[7px]  h-[2px] left-1/2 top-[7px] bg-secondary-color"
                style={{ width: "calc(100% - 14px)" }}
              ></div>
              <div
                className="absolute  w-full me-[7px]  h-[2px] right-1/2 top-[7px] bg-secondary-color"
                style={{ width: "calc(100% - 14px)" }}
              ></div> */}
              <div
                className={`absolute  w-full me-[7px]  h-[2px] right-1/2 top-[7px] ${
                  currentStepNo >= 4 ? "bg-secondary-color" : "bg-[#E0E0E7]"
                }`}
                style={{ width: "calc(100% - 14px)" }}
              ></div>
            </div>
          </div>
          <div className="w-1/6">
            <div className="relative">
              <div className="relative flex flex-col items-center text-center jus">
                <img
                  // src={currentStepNo >= 6 ? StepCompleteIcon : StepInactiveIcon}
                  src={
                    currentStepNo >= 6
                      ? StepCompleteIcon
                      : currentStepNo == 5
                      ? StepProgressIcon
                      : StepInactiveIcon
                  }
                  className="w-4 h-4"
                />
                <span className="hidden lg:block  text-[0.75rem] text-[#898F8F] leading-[150%] font-normal font-poppins">
                  Logisztikai adatok
                </span>
              </div>
              {/* <div
                className="absolute  w-full ms-[7px]  h-[2px] left-1/2 top-[7px] bg-secondary-color"
                style={{ width: "calc(100% - 14px)" }}
              ></div>
              <div
                className="absolute  w-full me-[7px]  h-[2px] right-1/2 top-[7px] bg-secondary-color"
                style={{ width: "calc(100% - 14px)" }}
              ></div> */}
              <div
                className={`absolute  w-full me-[7px]  h-[2px] right-1/2 top-[7px] ${
                  currentStepNo >= 5 ? "bg-secondary-color" : "bg-[#E0E0E7]"
                }`}
                style={{ width: "calc(100% - 14px)" }}
              ></div>
            </div>
          </div>

          <div className="w-1/6">
            <div className="relative">
              <div className="relative flex flex-col items-center text-center jus">
                <img
                  // src={currentStepNo >= 7 ? StepCompleteIcon : StepInactiveIcon}
                  src={
                    currentStepNo >= 7
                      ? StepCompleteIcon
                      : currentStepNo == 6
                      ? StepProgressIcon
                      : StepInactiveIcon
                  }
                  className="w-4 h-4"
                />
                <span className="hidden lg:block  text-[0.75rem] text-[#898F8F] leading-[150%] font-normal font-poppins">
                  Összegzés
                </span>
              </div>
              {/* <div
                className="absolute  w-full me-[7px]  h-[2px] right-1/2 top-[7px] bg-secondary-color"
                style={{ width: "calc(100% - 14px)" }}
              ></div> */}
              <div
                className={`absolute  w-full me-[7px]  h-[2px] right-1/2 top-[7px] ${
                  currentStepNo >= 6 ? "bg-secondary-color" : "bg-[#E0E0E7]"
                }`}
                style={{ width: "calc(100% - 14px)" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepBar;
